import React, { FC, useState } from 'react';
import _noop from 'lodash/noop';
import { l10n, l10nhtml } from '@ott/l10n';
import Modal, { modalIcons } from '@ott/modal';
import Button from '@ott/button';
import SuccessIcon from '@ott/icon-success';

import { CommonProps } from '../../types';
import { defaultTexts } from '../../constants';
import SubscriptionForm from './blocks/SubscriptionForm';

import styles from './EmailSubscriptionModal.scss';

type Props = CommonProps & {
  /** Состояние видимости модалки */
  isOpen: boolean;
  /** Функция закрытия модалки */
  onClose: VoidFunction;
};

const EmailSubscriptionModal: FC<Props> = ({
  auth,
  className,
  isOpen = false,
  metrics,
  onClose = _noop,
  onSuccess = _noop,
  texts = defaultTexts,
}) => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccess = () => {
    setIsSuccess(true);
    onSuccess();
  };

  if (isSuccess) {
    return (
      <Modal
        isOpen={isOpen}
        specificLocators="success-modal"
        contentOptions={{
          icon: <SuccessIcon />,
          title: texts?.successTitle,
          footerContentNode: (
            <Button withFullWidth={true} onClick={onClose}>
              {l10n('emailSubscription.success.button')}
            </Button>
          ),
        }}
        onClose={onClose}
      >
        <div className={styles.successDescription}>{texts?.successDescription}</div>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentOptions={{
        title: texts?.title,
        icon: <modalIcons.ModalMessageIcon />,
      }}
      specificLocators="subscription-modal"
    >
      <div className={className}>
        <span className={styles.description}>{texts?.description}</span>

        <SubscriptionForm onSuccess={handleSuccess} auth={auth} metrics={metrics} />

        <span className={styles.details}>{l10nhtml('emailSubscription.content.details')}</span>
      </div>
    </Modal>
  );
};

export default EmailSubscriptionModal;
